var _g;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgArrowForward(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 23,
    height: 23,
    viewBox: "0 0 23 23",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "eva:arrow-back-fill"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Vector",
    d: "M4.9375 10.5627H16.0562L12.6531 6.4752C12.494 6.28374 12.4174 6.03692 12.4403 5.78902C12.4631 5.54112 12.5835 5.31245 12.775 5.15332C12.9665 4.99419 13.2133 4.91763 13.4612 4.94049C13.7091 4.96335 13.9377 5.08374 14.0969 5.2752L18.7844 10.9002C18.8159 10.9449 18.8441 10.9919 18.8688 11.0408C18.8688 11.0877 18.8687 11.1158 18.9344 11.1627C18.9769 11.2702 18.9991 11.3846 19 11.5002C18.9991 11.6158 18.9769 11.7302 18.9344 11.8377C18.9344 11.8846 18.9344 11.9127 18.8688 11.9596C18.8441 12.0085 18.8159 12.0555 18.7844 12.1002L14.0969 17.7252C14.0087 17.831 13.8983 17.9161 13.7736 17.9745C13.6488 18.0328 13.5127 18.0629 13.375 18.0627C13.156 18.0631 12.9437 17.9868 12.775 17.8471C12.6801 17.7684 12.6016 17.6717 12.5441 17.5626C12.4866 17.4536 12.4511 17.3342 12.4398 17.2114C12.4285 17.0886 12.4415 16.9648 12.4781 16.8471C12.5147 16.7293 12.5742 16.6199 12.6531 16.5252L16.0562 12.4377H4.9375C4.68886 12.4377 4.4504 12.3389 4.27459 12.1631C4.09877 11.9873 4 11.7488 4 11.5002C4 11.2516 4.09877 11.0131 4.27459 10.8373C4.4504 10.6615 4.68886 10.5627 4.9375 10.5627Z",
    fill: "white"
  }))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgArrowForward);
export default __webpack_public_path__ + "static/media/ArrowForward.f75e3ea1a6c9eca4b3c4e7d4b7366d4d.svg";
export { ForwardRef as ReactComponent };